module.exports = __webpack_public_path__ + "static/media/location.6aa3447c.svg";